import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function MailDisposition({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {

    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <p className="blue-info-text red-info-heading">
              This only applies to tenants that have paid a deposit this is not
              needed for sayrhino or sd waiver tenants.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text red-info-heading">
              If Refund is needed follow steps to send email to admin include a
              link to tenants page needing refund.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text red-info-heading">
              If check is needed print out disposition and mail with a check.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text red-info-heading">
              If the tenant has opted in to echeck for their refund no need to
              send a mail disposition.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text red-info-heading">
              If nothing is needed please state so in the message sent.
            </p>
          </Col>
          <Col span={24}>
            <h3 className="blue-info-text red-info-heading">
              print the disposition letter and mail out the deposit refund or
              invoice if you need a check request that the broker print it out.
            </h3>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default MailDisposition;
